import React from 'react';

import Image from 'next/image';

import { Box, Card, CardContent, Typography } from '@mui/material';


const CarCard = ({ car, setCar, setActiveStep, clickable }) => {
  

  const CarCardAttribute = ({ attr, value, clickable }) => {
    return (
      <Box
        display="flex"
        justifyContent="space-between"
        borderBottom="1px solid #ccc"
        borderColor="background.default"
        my={2}
        pb={0.5}
        onClick={
          clickable
            ? () => {
                if (attr === 'VIN') {
                  setCar({ ...car, vin: null });
                } else {
                  setActiveStep(0);
                }
              }
            : null
        }
        style={{ cursor: clickable ? 'pointer' : 'default' }}
      >
        <Box>
          <Typography color={value ? 'inherit' : 'textSecondary'}>{attr}</Typography>
        </Box>
        <Box color="primary.light" overflow="hidden">
          <Typography
            color="inherit"
            sx={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              ml: 4,
              textOverflow: 'ellipsis',
            }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <Box width={325} minHeight={400} mr={4}>
      <Card 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: '100%',
          height: '100%',
        }}
      >
        <Box
          width="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={2}
          mr={1}
        >
          <Image
            src="/img/placeholder-car.jpg"
            title="Car card"
            alt={`My ${car.make}`}
            width={144}
            height={144}
            quality={100}
          />
        </Box>
        <CardContent>
          <CarCardAttribute attr="Make" value={car.make} clickable={clickable} />
          <CarCardAttribute attr="Model" value={car.model} clickable={clickable} />
          <CarCardAttribute attr="Year" value={car.year} clickable={clickable} />
          <CarCardAttribute attr="Type" value={car.type} clickable={clickable} />
          {car.vin && clickable && (
            <CarCardAttribute attr="VIN" value={car.vin} clickable={clickable} />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default CarCard;
